import React from 'react'
import PoorText from 'components/PoorText'
import Link from 'components/Link'
import PropTypes from 'prop-types'

import './MarketInsightLinkWithDescriptionBlock.scss'

const MarketInsightLinkWithDescriptionBlock = ({
    heading,
    introHtml,
    link
}) => {
    return (
        <div className='market-insight-link-with-description-block'>
            {heading && <h4 className='market-insight-link-with-description-block__heading'>{heading}</h4>}
            {introHtml && <PoorText text={introHtml} className='market-insight-link-with-description-block__intro poor-text_in-market-insight-link-with-description-block' />}
            {link && 
                <div className='market-insight-link-with-description-block__link-holder'>
                    <Link
                        {...link}
                        className='market-insight-link-with-description-block__link'
                    />
                </div>
            }
        </div>
    )
}

MarketInsightLinkWithDescriptionBlock.propTypes = {
    heading: PropTypes.string,
    introHtml: PropTypes.string,
    link: PropTypes.exact(Link.propTypes)
}

export default MarketInsightLinkWithDescriptionBlock